import React, { useState } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Chip from "@mui/material/Chip";
import TableToolbar from "components/MDTable/tableToolbar";
import TableHeader from "components/MDTable/tableHeader";
import { Order } from "components/MDTable/helper";
import { ITableHeader } from "types/Table";
import TablePaginationActions from "components/MDTable/tablePagination";
import MDBox from "components/MDBox";
import { useSelector } from "react-redux";
import { getLoadingStatus } from "redux/slices/notificationSlice";
import CircularProgress from "@mui/material/CircularProgress";
import InputDebounce from "components/MDInput/inputDebounce";
import { Rewards } from "types/Voucher";
import { stringTimeStampToDate } from "helper/date-helper";

type TableType = {
  header: ITableHeader[];
  rows: Rewards;
  onReload: () => void;
  onPageChanged: (newPage: number) => void;
};
const RewardTable: React.FC<TableType> = (props) => {
  const { header, rows, onReload, onPageChanged } = props;
  const { rewards = [] } = rows;
  const [order, setOrder] = useState<Order>("desc");
  const [orderBy, setOrderBy] = useState<string>("");
  const [page, setPage] = useState<number>(0);
  const isLoading = useSelector(getLoadingStatus);

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: string
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    onPageChanged(newPage);
    setPage(newPage);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Paper sx={{ width: "100%", mb: 2 }}>
        <TableToolbar
          numSelected={0}
          tableName={"Rewards"}
          onReload={onReload}
        />

        {isLoading ? (
          <MDBox display={"flex"} justifyContent={"center"} mt={3}>
            <CircularProgress color={"primary"} />
          </MDBox>
        ) : (
          <TableContainer>
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size={"medium"}
            >
              <TableHeader
                numSelected={0}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={() => {}}
                onRequestSort={handleRequestSort}
                rowCount={Number(rows.total)}
                headCells={header}
                disableCheckbox={true}
              />
              <TableBody>
                {rewards.map((row, index) => {
                  return (
                    <TableRow hover tabIndex={-1} key={index}>
                      <TableCell align="right">{row.customer_name}</TableCell>
                      <TableCell align="right">{row.reward_name}</TableCell>
                      <TableCell align="right">
                        <Chip
                          label={row.status}
                          size="small"
                          sx={{
                            backgroundColor:
                              row.status === "redeemed"
                                ? "#1976d2"
                                : row.status === "active"
                                ? "#2e7d32"
                                : undefined,
                            color:
                              row.status === "redeemed" ||
                              row.status === "active"
                                ? "#fff"
                                : undefined
                          }}
                        />
                      </TableCell>
                      <TableCell align="right">
                        {row.claimed ? (
                          stringTimeStampToDate(row.claimed)
                        ) : (
                          <Chip
                            label="Not yet redeemed"
                            size="small"
                            variant="outlined"
                          />
                        )}
                      </TableCell>
                      <TableCell align="right">
                        {stringTimeStampToDate(row.created_at)}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        <MDBox display={"inline-flex"} width={"100%"} justifyContent={"end"}>
          <InputDebounce
            type="number"
            name="search page"
            placeholder="search specify page"
            onChange={(value: string) => {
              const page = Number(value);
              handleChangePage(null, page === 0 ? 1 : page - 1);
            }}
            width={"10%"}
          />
          <TablePagination
            rowsPerPageOptions={[20]}
            component="div"
            count={Number(rows.total)}
            rowsPerPage={20}
            page={Number(rows.total) <= 0 ? 0 : page}
            onPageChange={handleChangePage}
            ActionsComponent={TablePaginationActions}
          />
        </MDBox>
      </Paper>
    </Box>
  );
};
export default RewardTable;
